import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters([
      'userInfo',
      'permissions',
    ]),
    checkFixed() {
      if (window.innerWidth >= 768)
        return 'right'
      return false
    },
  }
}


// WEBPACK FOOTER //
// ./src/utils/computedCommon.js